import React from "react";
import { Col, Row } from "react-bootstrap";
import LabelController from "../../../atoms/Label/LabelController";
import LabelInsideInputController from "../../../atoms/InputController/LabelInside/Label-Insdie-Input-Controller/LabelInsideInputController";
import { useSelectedLeadType } from "../../../../slices/leads/selector";
import { LEAD_TYPE } from "../../../../pages/leads-management/models/ILead";
import { phoneRegex } from "../../../../utils/validationUtils";

const LeadSection = ({ ...props }) => {
  let { firstName, lastName, jobTitle, company, mobile, phone, email } =
    props.newLeadContent;
  const { errors, touched, inputValue } = props;
  const leadType = useSelectedLeadType();
  return (
    <div className="box-container">
      <Row>
        <LabelController label={firstName.label} />
        <Row>
          <Col sm={6}>
            <LabelInsideInputController
              value={inputValue[firstName.name]}
              name={firstName.name}
              placeholder={firstName.name}
              type={firstName.type}
              onChange={props.onChange}
              label={firstName.inputLabel}
              errors={errors}
              touched={touched}
            />
          </Col>
          <Col sm={6}>
            <LabelInsideInputController
              touched={touched}
              value={inputValue[lastName.name]}
              name={lastName.name}
              placeholder={lastName.name}
              type={lastName.type}
              onChange={props.onChange}
              label={lastName.inputLabel}
              errors={errors}
              optional={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            {leadType === LEAD_TYPE.BUSINESS && (
              <LabelInsideInputController
                value={inputValue[jobTitle.name]}
                name={jobTitle.name}
                placeholder={jobTitle.name}
                type={jobTitle.type}
                onChange={props.onChange}
                label={jobTitle.inputLabel}
                errors={errors}
                touched={touched}
              />
            )}
          </Col>
          <Col sm={6}>
            {leadType === LEAD_TYPE.BUSINESS && (
              <LabelInsideInputController
                touched={touched}
                value={inputValue[company.name]}
                name={company.name}
                placeholder={company.name}
                type={company.type}
                onChange={props.onChange}
                label={company.inputLabel}
                errors={errors}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Row>
              <Col sm={6}>
                <LabelInsideInputController
                  value={inputValue[mobile.name]}
                  name={mobile.name}
                  placeholder={mobile.name}
                  type={mobile.type}
                  inputMode={mobile.inputMode}
                  pattern={phoneRegex.source}
                  onChange={props.onChange}
                  label={mobile.inputLabel}
                  errors={errors}
                  touched={touched}
                />
              </Col>
              <Col sm={6}>
                <LabelInsideInputController
                  touched={touched}
                  value={inputValue[phone.name]}
                  name={phone.name}
                  placeholder={phone.name}
                  type={phone.type}
                  inputMode={mobile.inputMode}
                  pattern={phoneRegex.source}
                  onChange={props.onChange}
                  label={phone.inputLabel}
                  errors={errors}
                  optional={true}
                />
              </Col>
            </Row>
          </Col>
          <Col sm={6}>
            <LabelInsideInputController
              touched={touched}
              value={inputValue[email.name]}
              name={email.name}
              placeholder={email.name}
              type={email.type}
              onChange={props.onChange}
              label={email.inputLabel}
              errors={errors}
            />
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default LeadSection;
